import { tagManagerEvent } from "event-tracker/gtm-events";
import {
  ANNO_DOMINI,
  HENRIQUE_E_JULIANO,
  KAMILLA_FIALHO,
} from "shared/constants/SpecialCampaignConst";
import { SpecialCampaignEnum } from "shared/enums/SpecialCampaignEnum";

const BUSINESS_CONTEXT_BY_CAMPAIGN: Record<SpecialCampaignEnum, string> = {
  [SpecialCampaignEnum.AnnoDomini]: ANNO_DOMINI,
  [SpecialCampaignEnum.HenriqueEJuliano]: HENRIQUE_E_JULIANO,
  [SpecialCampaignEnum.KamillaFialho]: KAMILLA_FIALHO,
};

export const getSpecialCampaignEventParams = (
  campaign: SpecialCampaignEnum
) => {
  const businessContext = BUSINESS_CONTEXT_BY_CAMPAIGN[campaign];

  return {
    ...tagManagerEvent.Home.S4A_HOME_DIAGNOSED,
    screenName: "HOME_V2",
    businessContext,
  };
};
